var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummySquarAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2857 96C7.45714 96 5.03571 94.9762 3.02143 92.9286C1.00714 90.881 0 88.4762 0 85.7143V10.2857C0 7.52381 1.00714 5.11905 3.02143 3.07143C5.03571 1.02381 7.45714 0 10.2857 0H85.7143C88.5429 0 90.9643 1.02381 92.9786 3.07143C94.9929 5.11905 96 7.52381 96 10.2857V85.7143C96 88.4762 94.9929 90.881 92.9786 92.9286C90.9643 94.9762 88.5429 96 85.7143 96H10.2857ZM22.2857 75.4286H73.742C74.7711 75.4286 75.5238 74.9524 76 74C76.4762 73.0476 76.381 72.1429 75.7143 71.2857L60.2857 50.7143C59.7857 49.9524 59.119 49.5714 58.2857 49.5714C57.4524 49.5714 56.7857 49.9524 56.2857 50.7143L51.1341 57.5648C46.9898 63.0758 38.7201 63.0791 34.5714 57.5714C34.0714 56.8095 33.4048 56.4286 32.5714 56.4286C31.7381 56.4286 31.0714 56.8095 30.5714 57.5714L20.3117 71.2894C19.6277 72.1441 19.5357 73.0476 20.0357 74C20.5357 74.9524 21.2857 75.4286 22.2857 75.4286Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummySquarAvatar);
export default __webpack_public_path__ + "static/media/dummySquarAvatar.65d11e4cbd67a25e2f24db490be9916c.svg";
export { ForwardRef as ReactComponent };